import DepartamentoApiService from "../../../../services/api/DepartamentoApiService";
import FilialApiService from "../../../../services/api/FilialApiService";
import UtilService from "../../../../services/util";

/** 
 * Informações das colunas para lista de colaboradores
 * @type {{
 *   groups: Array<{
 *      header: string,
 *      fields: Array<{
 *        label: string,
 *        placeholder: string,
 *        name: string,
 *        type: string,
 *        size: number,
 *        className: string
 *      }>
 *   }
 * }>} 
*/
export const getFormFields = async () => {
    return {
        groups: [
            {
                header: '',
                shouldRender: (form) => {
                    return ![null, undefined].includes(form.cod);
                },
                fields: [
                    {
                        label: 'Código',
                        placeholder: '',
                        name: 'cod',
                        type: 'text',
                        size: 3,
                        readOnly: true
                    },
                ]

            },
            {
                header: '',
                fields: [
                    {
                        label: 'Sigla',
                        placeholder: 'Ex: TI ou RH...',
                        name: 'sigla',
                        type: 'text',
                        size: 3,
                        max: 10,
                    },
                    {
                        label: 'Nome',
                        placeholder: 'Ex: Tecnologia, ou Recursos Humanos...',
                        name: 'nome',
                        type: 'text',
                        size: 4,
                        max: 60,
                        readOnly: true,
                        disabled: true
                    },
                ]
            },
            {
                header: '', 
                fields: [
                    {
                        label: 'Descrição',
                        placeholder: 'Digite aqui descrição, observações ou detalhes...',
                        name: 'descricao',
                        type: 'textarea',
                        size: 6,
                        max: 300
                    },
                ]
            },
            {
                header: 'Ativação',
                fields: [
                    {
                        label: 'Cadastro Ativo',
                        placeholder: '',
                        name: 'ativo',
                        type: 'swicth',
                        defaultChecked: true,
                        defaultValue: true,
                        size: 2,
                    },
                ]
            }
        ]
    };
}

const ColaboradorNewInfo = { getFormFields };

export default ColaboradorNewInfo;
